import React, { useEffect, useState } from 'react';
import { useRequest } from '../hooks/useRequest';
import PropTypes from 'prop-types';

const Undertaking = (props) => {
  const { request } = useRequest();
  const [ids, setIds] = useState(); // eslint-disable-line no-unused-vars
  const [isAllowed, setIsAllowed] = useState(1); // eslint-disable-line no-unused-vars

  const approved = () => {
    request('post/signContract', {
      method: 'POST',
      body: {
        contractId: ids
      }
    }).then(() => {
      console.log('Approved Contract');
      props.isShowFunc(false);
    });
  };
  useEffect(() => {
    request('post/checkUserHeyAccess', {
      method: 'GET'
    }).then((res) => {
      if (res.data.result.isAllowed == true) {
        request('post/checkContract', {
          method: 'GET'
        }).then((res) => {
          setIsAllowed(res.data.result.contractPdfFile);
          setIds(res.data.result.id);
          //props.isShowFunc(true);
        });
      }
    });
  }, []);

  useEffect(() => {
    if (isAllowed !== undefined) {
      console.log('isAllowed', isAllowed);
    }
  }, [isAllowed]);

  return props.isShow == true ? (
    <div>
      <div className="undertaking">
        <object data={isAllowed} type="application/pdf" width="100%" height="80%">
          <p>
            Alternative text - include a link <a href={isAllowed}>to the PDF!</a>
          </p>
        </object>

        <div className="undertaking--p--button" onClick={approved}>
          {' '}
          Okudum Anladım
        </div>
      </div>
    </div>
  ) : (
    ''
  );
};
Undertaking.propTypes = {
  isShowFunc: PropTypes.func,
  isShow: PropTypes.bool
};

export default Undertaking;
